module.exports = __webpack_public_path__ + "static/media/am.dfe2bd05.svg";